import { Injectable } from '@angular/core';
import {ItemOfSchoolsArgumentListModel} from '@app/core/model/integration-models';
import {MetadataModel} from '@app/core/model/filtering/metadata-model';
import {PredicateModel} from '@app/core/model/filtering/predicate-model';
import {DENIED_PREDICATES_LIST} from '@app/core/model/filtering/filter-predicate';
import {DataAttribute} from '@app/views/admin/application-settings/models/data-attribute.model';

@Injectable()
export class FiltersListService {

    static readonly SCHOOL_ID_EXCEPTIONS = ['courseSchoolId'];

    static checkIsGradeSelected(type: string): boolean {
        if (type) {
            return (type.toLowerCase().substr(-5) === 'grade') || (type.toLowerCase().substr(-6) === 'grades');
        }
        return false;
    }

    static getGradeAttrProperties(eduToneAttributeList: DataAttribute[]): DataAttribute[] {
        const gradeAttrList = eduToneAttributeList.filter((attr: DataAttribute) =>
            FiltersListService.checkIsGradeSelected(attr.propertyName));
        return (gradeAttrList.length > 0) ? gradeAttrList : [];
    }

    static checkIsSchoolIdSelected(type: string): boolean {
        if (type) {
            return !FiltersListService.SCHOOL_ID_EXCEPTIONS.includes(type)
                && (type.toLowerCase().substr(-8) === 'schoolid');
        }
        return false;
    }

    static checkIsGuidSelected(type: string): boolean {
        if (type) {
            return (type.toLowerCase().substr(-12) === 'guid');
        }
        return false;
    }

    static checkIsSchoolNameSelected(type: string): boolean {
        if (type) {
            return (type.toLowerCase().substr(-10) === 'schoolname');
        }
        return false;
    }

    /*
     * transform Abbott School [SIS ID: UHaZpThVxq] to Abbott School - UHaZpThVxq
     */
    static transformSchoolWithSISIDFriendlyName(value: string): string {
        return value.replace('[sis id:', '-').replace(']', '').trim();
    }

    static filterDeniedPredicates(predicatesMetadata: MetadataModel[]): MetadataModel[] {
        return predicatesMetadata.map((metadata: MetadataModel) => {
            if (DENIED_PREDICATES_LIST.get(metadata.type)) {
                metadata.predicates = metadata.predicates.filter((predicate: PredicateModel) =>
                    predicate.name !== DENIED_PREDICATES_LIST.get(metadata.type));

                if (metadata.defaultPredicate === DENIED_PREDICATES_LIST.get(metadata.type)) {
                    metadata.defaultPredicate =
                        metadata.predicates.length > 0
                            ? metadata.predicates[0].name
                            : null;
                }
            }
            return metadata;
        });
    }

    constructor() { }

    areListsOfSchoolsEquals(newListOfSchools: ItemOfSchoolsArgumentListModel[], oldListOfSchools: ItemOfSchoolsArgumentListModel[]): boolean {
        if (newListOfSchools
            && oldListOfSchools
            && newListOfSchools.length === oldListOfSchools.length) {

            return newListOfSchools.every((newSchool: ItemOfSchoolsArgumentListModel) => oldListOfSchools.some((oldSchool: ItemOfSchoolsArgumentListModel) => oldSchool.idsString === newSchool.idsString));
        }
    }

    processIntelisenseSearch(searchFilterValue: string, filterFunction: (searchFilterValue: string) => void): void {
        const searchValuesArray = this.getIntelisenseSearchArray(searchFilterValue);
        this.searchInArray(searchValuesArray, filterFunction);
    }

    getIntelisenseSearchArray(str: string): string[] {
        const re = /"([^"\\]*(?:\\.[^"\\]*)*)"/g;
        const quotedResult: string[] = [];
        let m;
        while ((m = re.exec(str)) !== null) {
            quotedResult.push(m[1].replace('\\"', '"'));
        }
        str = str.replace(re, '');
        str = str.replace(/\s\s+/g, ' ');
        const strResult = (str === '') ? [] : str.split(' ');
        return [...quotedResult, ...strResult];
    }

    searchInArray(searchValuesArray: string[], filterFunction: (searchFilterValue: string) => void): void {
        searchValuesArray.forEach((searchValue: string) => {
            if (searchValue.trim()) {
                filterFunction(searchValue.trim());
            }
        });
    }
}
